import React from "react";
import { Main } from "../components/sections/cart/Main";

export const Cart = () => {
  return <Main />;
};
